import {
    RESET_USER_PASSWORD,
    RESET_USER_PASSWORD_FAILURE,
    RESET_USER_PASSWORD_SUCCESS,
} from 'store/actions/types';

export const resetUserPassword = (payload) => {
    return {
        type: RESET_USER_PASSWORD,
        payload: payload,
    };
};

export const resetUserPasswordFailure = (error) => {
    return {
        type: RESET_USER_PASSWORD_FAILURE,
        error: error,
    };
};

export const resetUserPasswordSuccess = (response) => {
    return {
        type: RESET_USER_PASSWORD_SUCCESS,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/users/userPassword.js